import { render, staticRenderFns } from "./ReportCountPagination.vue?vue&type=template&id=45fe4a96&scoped=true&"
import script from "./ReportCountPagination.vue?vue&type=script&lang=js&"
export * from "./ReportCountPagination.vue?vue&type=script&lang=js&"
import style0 from "./ReportCountPagination.vue?vue&type=style&index=0&id=45fe4a96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fe4a96",
  null
  
)

export default component.exports